import BossModel from "@/models/BossModel";
import Proposal from '@/models/Proposal/Proposal';
import Airline from '@/models/Airline/Airline'

export default class Placeholder extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'proposal/placeholder';

    /**
     *
     * @type {string}
     */
    static entity = 'placeholders';

    static fields() {
        return {
            id: this.number(null).nullable(),
            proposal_id: this.number(null).nullable(),
            name: this.attr(null),
            description: this.attr(null),
            class: this.attr(null),
            airline_id: this.number(null).nullable(),
            flight_code: this.attr(null),
            sale_price: this.attr(null),
            adults_amount: this.number(null).nullable(),
            children_amount: this.number(null).nullable(),
            babies_amount: this.number(null).nullable(),
            purchase_price: this.attr(null),
            proposal: this.belongsTo(Proposal, 'proposal_id'),
            airline: this.belongsTo(Airline, 'airline_id'),
        }
    }

}
